import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { Trans } from 'react-i18next';
import { useChallenge, useUnits } from '../../../hooks';
import { MedalIcon } from '../../icons';
function RankCard({
  challengeTemplate,
  progress,
  numberOfParticipants,
  withoutPointsUnit
}) {
  const {
    getProgressValue
  } = useChallenge();
  const {
    toOrdinal
  } = useUnits();
  if (!challengeTemplate || progress === null) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: progress ? '#FFF5D0' : '#efefef',
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    flexShrink: 0,
    gap: 1,
    padding: 2,
    width: "100%"
  }, /*#__PURE__*/React.createElement(MedalIcon, {
    fontSize: "small",
    sx: {
      color: progress ? '#EBAF25' : 'rgba(0, 0, 0, 0.54)'
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, progress && numberOfParticipants !== undefined ? /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("span", {
      key: 0,
      style: {
        fontWeight: 700
      }
    })],
    count: numberOfParticipants,
    i18nKey: "commons.challenges.rank_company",
    values: {
      rank: progress.rank !== undefined ? toOrdinal(progress.rank) : '-',
      count: numberOfParticipants,
      progress: getProgressValue(challengeTemplate.type, progress.progressValue, {
        withoutPointsUnit
      })
    }
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })));
}
export default RankCard;